<div class="container" [ngClass]="{ checked: isFilterEnabled(), 'no-line': !showLine() }">
  <div class="title" [matTooltip]="titleTooltip()" (click)="titleClickHandler()">
    @if (svgIcon()) {
      <mat-icon [svgIcon]="svgIcon()"></mat-icon>
    }
    @if (icon()) {
      <mat-icon>{{ icon() }}</mat-icon>
    }

    <h3 class="title-filter">{{ title() }}</h3>
  </div>
  <div class="toggle">
    @if (showToggle()) {
      <mat-slide-toggle
        (change)="toggleChangeHandler($event)"
        [checked]="isFilterEnabled()"
        [disabled]="disabled()"
      ></mat-slide-toggle>
    }
  </div>
</div>
